import type {WidgetFragment as Widget} from 'nutshell-graphql-types';

import {CustomFieldsWidgetShell} from '../../../../core-entity/widgets/custom-fields-widget/components/custom-fields-widget-shell';
import {LegacyIdRow} from '../../../../core-entity/widgets/custom-fields-widget/components/legacy-id-row';
import {useGetWidgetCustomFields} from '../../../../core-entity/widgets/custom-fields-widget/graphql/hooks/use-get-widget-custom-fields';

import {useContactCustomFieldHandlers} from '../../hooks/use-contact-custom-field-handlers';

import {useGetContactLegacyId} from './graphql/hooks/use-get-contact-legacy-id';
import {useUpdateContactLegacyId} from './graphql/hooks/use-update-contact-legacy-id';

interface Props {
    contactId: string;
    widget: Widget;
}

export function ContactAllCustomFieldsWidget(props: Props) {
    const handlers = useContactCustomFieldHandlers(props.contactId);
    const {customFields, isFirstLoad: isCustomFieldsFirstLoad} = useGetWidgetCustomFields(
        props.contactId,
        props.widget.id
    );
    const {
        legacyId,
        shouldShowLegacyId,
        isFirstLoad: isLegacyIdFirstLoad,
    } = useGetContactLegacyId(props.contactId);
    const {updateContactLegacyId} = useUpdateContactLegacyId();

    const isFirstLoad = isCustomFieldsFirstLoad || isLegacyIdFirstLoad;

    const extraRows = shouldShowLegacyId
        ? [
              <LegacyIdRow
                  key='legacy-id'
                  value={legacyId}
                  onUpdate={(newValue) => updateContactLegacyId(props.contactId, newValue)}
              />,
          ]
        : [];

    return (
        <CustomFieldsWidgetShell
            entityId={props.contactId}
            widget={props.widget}
            handlers={handlers}
            emptyStateKey='leadCustomFields'
            customFields={customFields}
            isFirstLoad={isFirstLoad}
            extraRows={extraRows}
        />
    );
}
